import { render } from "./MaintenanceModeSection.vue?vue&type=template&id=771a3a2a&scoped=true"
import script from "./MaintenanceModeSection.vue?vue&type=script&lang=js"
export * from "./MaintenanceModeSection.vue?vue&type=script&lang=js"

import "./MaintenanceModeSection.vue?vue&type=style&index=0&id=771a3a2a&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\registration2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771a3a2a"]])

export default __exports__